var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3905 2.83301H8.99998C8.63178 2.83301 8.33331 3.13147 8.33331 3.49967V29.4997C8.33331 29.8679 8.63178 30.1663 8.99998 30.1663H28.3333C28.7015 30.1663 29 29.8679 29 29.4997V9.44247C29 9.26567 28.9297 9.09611 28.8047 8.97107L22.8619 3.02827C22.7369 2.90324 22.5673 2.83301 22.3905 2.83301Z",
    fill: "white",
    stroke: "#8C7A67",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 2.83301V8.83301C22.3333 9.20121 22.6318 9.49967 23 9.49967H29",
    stroke: "#8C7A67",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 20.8337H16V20.167H26.3333C26.5174 20.167 26.6667 20.3162 26.6667 20.5003C26.6667 20.6844 26.5174 20.8337 26.3333 20.8337ZM26.3333 18.8337H16V18.167H26.3333C26.5174 18.167 26.6667 18.3162 26.6667 18.5003C26.6667 18.6844 26.5174 18.8337 26.3333 18.8337ZM26.3333 16.8337H16V16.167H26.3333C26.5174 16.167 26.6667 16.3162 26.6667 16.5003C26.6667 16.6844 26.5174 16.8337 26.3333 16.8337ZM26.3333 14.8337H16V14.167H26.3333C26.5174 14.167 26.6667 14.3162 26.6667 14.5003C26.6667 14.6844 26.5174 14.8337 26.3333 14.8337ZM26.3333 22.8337H16V22.167H26.3333C26.5174 22.167 26.6667 22.3162 26.6667 22.5003C26.6667 22.6844 26.5174 22.8337 26.3333 22.8337Z",
    fill: "#D1CCC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00002 25.1663H14.6667C15.4031 25.1663 16 24.5694 16 23.833V13.1663C16 12.43 15.4031 11.833 14.6667 11.833H4.00002C3.26365 11.833 2.66669 12.43 2.66669 13.1663V23.833C2.66669 24.5694 3.26365 25.1663 4.00002 25.1663Z",
    fill: "#185ABD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20819 20.7155C7.23022 20.8895 7.24452 21.0411 7.25139 21.1707H7.27679C7.28699 21.0479 7.30642 20.8998 7.33515 20.7258C7.36389 20.5521 7.39192 20.4054 7.41905 20.2861L8.59705 15.167H10.1205L11.3392 20.2094C11.4002 20.4583 11.451 20.7752 11.4915 21.1605H11.5118C11.5287 20.8945 11.571 20.5877 11.6388 20.24L12.6138 15.167H14L12.2939 22.5003H10.6739L9.51109 17.6422C9.47722 17.5023 9.43915 17.3201 9.39682 17.095C9.35449 16.8701 9.32825 16.7064 9.31815 16.6042H9.29789C9.28432 16.7235 9.25805 16.9007 9.21909 17.1358C9.18012 17.3712 9.14875 17.5449 9.12512 17.6575L8.03335 22.5003H6.38812L4.66669 15.167H6.07832L7.13975 20.2964C7.16339 20.4019 7.18615 20.5418 7.20819 20.7155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.6db241d8.svg";
export { ForwardRef as ReactComponent };